import { Tabs, Text } from "@asayinc/component-library";
import { Box } from "@mui/material";
import { Outlet, useMatch, useNavigate } from "react-router-dom";

import { PageContainer } from "src/components/containers/PageContainer/PageContainer";
import { REPORTS_TABS } from "src/constants/tabs";

export function Reports() {
  const navigate = useNavigate();
  const match = useMatch(`/reports/:activeTab`) as {
    params: { activeTab: string };
  };

  const handleTabChange = (value: string) => {
    navigate(`/reports/${value}`);
  };

  return (
    <PageContainer>
      <Text variant="h4" sx={{ pb: 4, pt: 10, px: 10 }}>
        Reports
      </Text>
      <Box sx={{ mx: 10 }}>
        <Tabs
          activeTab={match?.params?.activeTab || "share-range-analysis"}
          clickHandler={handleTabChange}
          tabs={REPORTS_TABS}
        />
      </Box>
      <Outlet />
    </PageContainer>
  );
}
